module.exports = __webpack_public_path__ + "media/in_the_silo_revised.a6b8722d.wav";